import Api from "./../../Services/Api/Api";
import UserHelper from "./../../Utils/Helpers/UserHelper";
import StorageHelper from "../../Utils/Helpers/StorageHelper";

const Auth = {
    login(instance, user, pass, key, cb) {
        cb = arguments[arguments.length - 1];

        if (UserHelper.getToken()) {
            if (cb) cb(true);
            this.onChange(true);
            return;
        }

        Api.post(
            "api/user/login",
            {
                key: key,
                user: user,
                pass: pass
            },
            res => {
                if (res.success === true) {
                    if (res.data.requerAceite) {
                        instance.setState({
                            acceptanceTerms: true,
                            preLogin: {
                                token: res.token,
                                user: res.data
                            },
                            disabled: false
                        });
                    } else {
                        if (parseInt(res.data.lgw_alterar_senha || 0) !== 0) {
                            instance.setState({ createNewPassword: true });
                            instance.setState({
                                preLogin: {
                                    token: res.token,
                                    user: res.data
                                }
                            });
                            instance.setState({
                                newPassword: {
                                    ...instance.state.newPassword,
                                    userId: res.data.id
                                }
                            });
                        } else {
                            UserHelper.setToken(res.token);
                            UserHelper.setUser(res.data);
                        }
                    }
                }

                if (cb) cb(res.success, res.msg);
            }
        );
    },
    logout(instance, user, key, cb) {
        Api.post(
            "api/user/logout",
            {
                user: user
            },
            res => {
                StorageHelper.set('loginWithToken', false, false);
            }
        );
    },
    passwordReset(login, email, key, callback) {
        Api.post(
            "api/password/reset",
            {
                "email": email,
                "username": login,
                "key": key
            },
            response => {
                if (callback) {
                    if (response.data === undefined) {
                        callback(false, "Ocorreu um erro, tente novamente.");
                        return;
                    }

                    callback(response.success, response.msg);
                }
            }
        );
    },
    updatePassword(newPassword, currentPassword, userId, key, callback) {
        Api.post(
            "api/password/update",
            {
                "newPass": newPassword,
                "currentPass": currentPassword,
                "userId": userId,
                "key": key
            },
            response => {
                if (callback) callback(response.success, response.msg);
            }
        );
    },
    loginWithAccessToken(token, key, callback) {

        Api.post(
            "api/user/suporteAccess",
            {
                token: token,
                key: key
            },
            response => {
                if (response.success === true) {
                    UserHelper.setToken(response.token);
                    UserHelper.setUser(response.data);
                }

                if (callback) callback(response.success, response.error);
            }
        )
    }
};

export default Auth;
